export default "__VITE_ASSET__Ba7RFRe2__ 100w";